module.exports = __webpack_public_path__ + "static/media/1POLICY42.6de0a2e9.jpg";